/**
 * Created by hmahad on 2/2/2017.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../assets/ak-cached/2h/stylesheets/modules/loader.css';
import styled from "styled-components";


const NickNameLoader = styled.div`
position:absolute;
width:100%;
padding-top:250px;
left:0;right:0;top:0;bottom:0;
background-color: rgba(255,255,255,0.7);
z-index:9999;
`;

const LoaderDiv = styled.div`
position: absolute;
height: 100px;
width: 100px;
top: 50%;
left: 50%;
margin-left: -70px;
margin-top: 10px;
`;

export default class Loader extends Component { // eslint-disable-line
  render() {
    const class_name = this.props.className ? `spinner ${this.props.className}` : 'spinner';
    let renderMobileView = window.innerWidth < 600 ? true: false;
    return (
      this.props.nickNameLoader ?
        <NickNameLoader>
        <div className={class_name + ' nicknamespinner'} />
        <div style={{fontSize:"2.5rem",fontWeight:"bold",textAlign:"center"}}> {this.props.spinnerMsg ? this.props.spinnerMsg: ""}</div>
      </NickNameLoader> :
      this.props.smallLoader ?
      <div style={{padding:"5%"}}>
        <div className={'smallspinner'} />
        <div style={{fontSize:"2.5rem",fontWeight:"bold",textAlign:"center"}}> {this.props.spinnerMsg ? this.props.spinnerMsg: ""}</div>
      </div>
      :
          renderMobileView ?
            <LoaderDiv>
              <div className={class_name} />
              <div style={{ fontSize: "2.5rem", fontWeight: "bold", textAlign: "center" }}> {this.props.spinnerMsg ? this.props.spinnerMsg : ""}</div>
            </LoaderDiv> :
            <div style={{ padding: "20%" }}>
              <div className={class_name} />
              <div style={{ fontSize: "2.5rem", fontWeight: "bold", textAlign: "center" }}> {this.props.spinnerMsg ? this.props.spinnerMsg : ""}</div>
            </div>
    );
  }
}
Loader.propTypes = {
  className: PropTypes.string,
};
